import { css, styled } from 'next-yak';

import {
  scale005,
  scale010,
  scale020,
  scale050,
  scale100,
  xdlColorProgressBadgeBackground01,
  xdlColorProgressBadgeBackground02,
  xdlColorProgressBadgeBackground03,
  xdlColorProgressBadgeBackground04,
  xdlColorTextOnDark,
  xdlColorTextOnLight,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import type { ProgressBadgeFractionalVariants } from './progress-badge-fractional.types';

type ProgressBadgeFractionalTProps = {
  $progress: number;
  $variant?: ProgressBadgeFractionalVariants;
};

export const variants = {
  default: css`
    background-color: ${xdlColorProgressBadgeBackground04};
  `,
  singleColor: css`
    background-color: ${xdlColorProgressBadgeBackground04};
  `,
};

// *** Components ***
export const ProgressBadgeFractional = styled.span<ProgressBadgeFractionalTProps>`
  border-color: ${xdlColorTextOnDark};
  border-radius: ${scale050};
  border-style: solid;
  border-width: ${scale010};
  display: inline-flex;
  flex-shrink: 0;
  height: ${scale100};
  padding-inline-end: ${scale020};
  padding-inline-start: ${scale020};
  transition: background-image 0.3s ease;

  ${({ $variant, $progress }) => {
    switch ($variant) {
      case 'default':
        switch (true) {
          case $progress <= 39:
            return css`
              background-color: ${xdlColorProgressBadgeBackground01};
            `;
          case $progress <= 79:
            return css`
              background-color: ${xdlColorProgressBadgeBackground02};
            `;
          case $progress <= 99:
            return css`
              background-color: ${xdlColorProgressBadgeBackground03};
            `;
          default:
            return variants.default;
        }
      case 'singleColor':
        return variants.singleColor;
      default:
        return $variant satisfies undefined;
    }
  }}
`;

export const Text = styled(BodyCopy)`
  /* BodyCopy's styled-components stylesheet loads after the extracted CSS. */
  && {
    color: ${xdlColorTextOnLight};
  }
  inset-block-start: -${scale005};
  position: relative;
`;
